import { render } from "./send.vue?vue&type=template&id=7c2a19ba"
const script = {}

import exportComponent from "/Users/einaroberg/projects/tjing-majblomman/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__